import { CheckCircle, XCircle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { safeString } from '@/lib/utils';

export default function ActionResult({ results }) {
  if (!results || typeof results !== 'object') return null;

  const entries = Object.entries(results);

  return (
    <div className="ml-11 space-y-2">
      {entries.map(([stepKey, result]) => {
        const isSuccess = result.status === 'success';
        const stepNum = parseInt(stepKey.replace('step_', ''), 10) + 1;

        return (
          <div
            key={stepKey}
            className={`flex items-start gap-2 p-3 rounded-lg border text-sm ${
              isSuccess
                ? 'bg-green-50 border-green-200 text-green-800 dark:bg-green-950/30 dark:border-green-800 dark:text-green-300'
                : 'bg-red-50 border-red-200 text-red-800 dark:bg-red-950/30 dark:border-red-800 dark:text-red-300'
            }`}
          >
            {isSuccess ? (
              <CheckCircle className="size-4 shrink-0 mt-0.5" />
            ) : (
              <XCircle className="size-4 shrink-0 mt-0.5" />
            )}
            <div className="flex items-center gap-2">
              <Badge variant={isSuccess ? 'secondary' : 'destructive'} className="text-[10px]">
                Step {stepNum}
              </Badge>
              {isSuccess ? (
                <span>Completed successfully</span>
              ) : (
                <span>{safeString(result.error?.detail, 'Failed')}</span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
